<div class="auth-container">
  <div class="header">
    <div class="logo">
      <img
        src="assets/vite-marketplace-logo-dark.svg"
        [alt]="translationService.getBrandLogoText()"
        height="50px"
      />
    </div>
    <h2>{{ translationService.getResetPasswordText() }}</h2>
  </div>
  <form [formGroup]="emailForm">
    <div class="form-groups margin-top-20">
      <div class="form-group margin-top-10">
        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getEmailAddressText() }}</mat-label>
          <input matInput type="email" name="email" formControlName="email" />
        </mat-form-field>
      </div>
    </div>
    <div class="actions margin-top-10">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="submit()"
      >
        <mat-icon>reset</mat-icon>
        {{ translationService.getResetPasswordText() }}
      </button>
      <span
        >{{ translationService.getAlreadyHaveAccountText() }}
        <a [routerLink]="['auth/login']">{{
          translationService.getLoginText()
        }}</a></span
      >
    </div>
  </form>
</div>
